import script from "./wTransferDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./wTransferDetail.vue?vue&type=script&setup=true&lang=ts"

import "./wTransferDetail.vue?vue&type=style&index=0&id=532ea806&lang=scss"

const __exports__ = script;

export default __exports__